<template>
  <div class="uk-container SectionThree">
    <div uk-grid>
      <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s DetailsConThree">
        <h1 class="uk-text-center uk-text-middle AppTitle Title" data-aos="zoom-in">
          {{'home_section.title_2'|translate}}
        </h1>
      </div>
      <div class="uk-child-width-1-3@m" uk-grid>
        <div v-for="(item, index) in offers" :key="index">
          <h4 class="AppTitle">{{item.title}}</h4>
          <div class="uk-card uk-card-default" data-aos="zoom-in" :data-aos-delay="index*50">
            <div class="uk-card-media-top media-con">
              <img :src="item.imgPath" class="uk-height-medium" alt="">
            </div>
            <div class="uk-card-body">
<!--              <h4 class="card-title">{{item.description}}</h4>-->
              <div class="button-panel">
                <button class="uk-button uk-button-secondary" @click="goToLink(item.link)">
                  {{'view_more'|translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../router'

export default {
  name: 'HomeSectionThree',
  props: [
    'offers'
  ],
  methods: {
    goToLink: function (link) {
      router.push(link)
    }
  }
}
</script>

<style scoped>
  .SectionThree {
    padding-top: 40px;
    padding-bottom: 80px;
  }

  .DetailsConThree {
    padding-top: 40px;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .media-con {
    text-align: center;
  }

  .card-title {
    text-align: center;
  }

  .button-panel {
    text-align: center;
    padding: 30px 0 0 0;
  }

  @media only screen and (max-width: 959px) {
    .SectionThree {
      padding-top: 0;
      padding-bottom: 40px;
    }
  }
</style>
